const AzimuthSwatch: React.FC<{
    rotation: number;
    padding?: React.CSSProperties['padding'];
    margin?: React.CSSProperties['margin'];
    size?: React.CSSProperties['width'] & React.CSSProperties['height'];
}> = ({ rotation, size: set_size, ...css }) => {
    const size = set_size ?? 20;
    return (
        <svg
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                transform: `rotate(${rotation}deg)`,
                width: size,
                height: size,
                ...css,
            }}
        >
            <circle cx={16} cy={16} r={2} stroke="grey" />
            <line x1="16" y1="32" x2="16" y2="0" stroke="black" />
            <line x1="12" y1="8" x2="16" y2="0" stroke="black" />
            <line x1="20" y1="8" x2="16" y2="0" stroke="black" />
        </svg>
    );
};

AzimuthSwatch.displayName = 'AzimuthSwatch';
export default AzimuthSwatch;
